var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictureIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H44V44H0V0Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41693 8.98384C6.31567 8.98384 6.23359 9.06592 6.23359 9.16717V34.8338C6.23359 34.9351 6.31568 35.0172 6.41693 35.0172H37.5836C37.6848 35.0172 37.7669 34.9351 37.7669 34.8338V9.16717C37.7669 9.06592 37.6848 8.98384 37.5836 8.98384H6.41693ZM2.93359 9.16717C2.93359 7.24338 4.49314 5.68384 6.41693 5.68384H37.5836C39.5074 5.68384 41.0669 7.24338 41.0669 9.16717V34.8338C41.0669 36.7576 39.5074 38.3172 37.5836 38.3172H6.41693C4.49313 38.3172 2.93359 36.7576 2.93359 34.8338V9.16717Z",
    fill: "#555555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2949 15.9092C13.7275 15.9092 14.0782 15.5586 14.0782 15.126C14.0782 14.6934 13.7275 14.3428 13.2949 14.3428C12.8624 14.3428 12.5117 14.6934 12.5117 15.126C12.5117 15.5586 12.8624 15.9092 13.2949 15.9092ZM9.76172 15.126C9.76172 13.1747 11.3436 11.5928 13.2949 11.5928C15.2463 11.5928 16.8282 13.1747 16.8282 15.126C16.8282 17.0773 15.2463 18.6592 13.2949 18.6592C11.3436 18.6592 9.76172 17.0773 9.76172 15.126Z",
    fill: "#555555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7487 22.0005L18.332 25.6672L23.832 19.2505L39.4154 31.1672V34.8338C39.4154 35.8463 38.5946 36.6672 37.582 36.6672H6.41536C5.40284 36.6672 4.58203 35.8463 4.58203 34.8338V31.1672L13.7487 22.0005Z",
    fill: "#2F88FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5808 18.1768C23.1506 17.5121 24.1404 17.4081 24.8359 17.9399L40.4192 29.8566C40.8275 30.1688 41.0669 30.6534 41.0669 31.1673V34.834C41.0669 36.7578 39.5074 38.3173 37.5836 38.3173H6.41693C4.49314 38.3173 2.93359 36.7578 2.93359 34.834V31.1673C2.93359 30.7297 3.10743 30.31 3.41687 30.0006L12.5835 20.8339C13.178 20.2394 14.1245 20.187 14.781 20.7122L18.1188 23.3825L22.5808 18.1768ZM24.0708 21.5092L19.5864 26.7411C19.0075 27.4165 17.9974 27.5114 17.3028 26.9557L13.8727 24.2116L6.23359 31.8508V34.834C6.23359 34.9352 6.31567 35.0173 6.41693 35.0173H37.5836C37.6848 35.0173 37.7669 34.9352 37.7669 34.834V31.9827L24.0708 21.5092Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureIcon);
export default __webpack_public_path__ + "static/media/picture_icon.cc23fb266a57b549df8a8c208a586e9d.svg";
export { ForwardRef as ReactComponent };